import React, { useState, useEffect, useRef } from "react";
import Grid from '@material-ui/core/Grid';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
// import 'rc-datepicker/lib/style.css';
import { DatePickerInput } from 'rc-datepicker';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import 'moment/locale/it.js';
import Moment from "moment";

let today = new Date();


const CreateActivities = (props) => {
    //// debugger;
    const [Lead, setLead] = useState(false);
    const [Opportunity, setOpportunity] = useState(false);
    const [Quotation, setQuotation] = useState(false);
    const [Complaint, setComplaint] = useState(false);
    const [SalesOrder, setSalesOrder] = useState(false);
    const [Others, setOthers] = useState(false);
    const [Employee, setEmployee] = useState(sessionStorage.UserName);
    const [Date, setDate] = useState('');
    const [UserType, setUserType] = useState(sessionStorage.UserType);
    const [StartTime, setStartTime] = useState('');
    const [EndTime, setEndTime] = useState('');
    const [MobileNo, setMobileNo] = useState('');
    const [Address, setAddress] = useState('');
    const [CustName, setCustName] = useState({ id: props.AccountID, List: props.AccountName });
    const [CustID, setCustID] = useState('');
    const [ActivityTypeID, setActivityTypeID] = useState('');
    const [ActivityType, setActivityType] = useState('Others');
    const [AccountID, setAccountID] = useState('');
    const [Description, setDescription] = useState('');
    const [CurDate, setCurDate] = useState('');
    const [ContactID, setContactID] = useState('');
    const [CustOptions, setCustOptions] = useState([]);
    const [Typecmb, setTypecmb] = useState([]);
    const [Contactcmb, setContactcmb] = useState([]);
    const [ActivityID, setActivityID] = useState(props.ActivityID);
    const [RefferenceID, setRefferenceID] = useState(props.RefDocumentID);
    const [Refferencecmb, setRefferencecmb] = useState([]);
    const [DisableUpdate, setDisableUpdate] = useState(props.DisableUpdate);
    const [DisableComplete, setDisableComplete] = useState(props.DisableComplete);
    const [DisableDelete, setDisableDelete] = useState(props.DisableDelete);
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const [responseContByIDDtls, fetchContByIDDtls] = UseFetchData();
    const [responseCust, fetchCustData] = UseFetchData();
    const [responseContDtls, fetchContDtls] = UseFetchData();
    const [responseRefferenceDtls, fetchRefferenceDtls] = UseFetchData();
    const [ResponseSave, fetchData] = UseFetchData();
    const [ResponseDisplay, fetchDisplayData] = UseFetchData();
    const [ResponseDate, fetchDate] = UseFetchData();
    const [ResponseDelete, fetchDelete] = UseFetchData();
    const [Status, setStatus] = useState('Pending');
    const [StatusC, setStatusC] = useState('Completed');
    const [Mode, setMode] = useState('');
    const [pageName, setpageName] = useState(props.pageName);
    const [AccType, setAccType] = useState('');
    const { value, onChange, ...rest } = props;
    const [cursor, setCursor] = useState(null);
    const ref = useRef(null);


    const validationSchema = Yup.object({
        ActivityTypeID: Yup.string().required('Required!'),
        Date: Yup.string().required('Required!'),
        StartTime: Yup.string().required('Required!'),
        EndTime: Yup.string().required('Required!'),
    });

    const MarkAsComplete = () => {
        var sts = "Complete"
        OnUpdate(sts);
        setMode('MarkAsComplete');
    }


    const ClearData = () => {
        setEmployee('');
        setUserType('');
        setActivityTypeID('');
        setStatus('');
        setDate('');
        setStartTime('');
        setEndTime('');
        setCustID('');
        setCustName('');
        setContactID('');
        setMobileNo('');
        setAddress('');
        setRefferenceID('');
        setCurDate('');
        setDescription('');
        setDisableUpdate(true);
        setDisableComplete(false);
        setDisableDelete(true);
    }

    const OnUpdate = (sts) => {
        var Statuss;
        var ActivityCategory;
        var EmployeeID = sessionStorage.UID;
        var UserID = sessionStorage.UID;
        var UserGrpID = sessionStorage.UserGroupID;
        var bodyFormData = new FormData();
        var OpporID, LeadID, QuotationID, SalesOrderID, Activityid;
        // debugger;
        if (ActivityType == "Opportunity" || props.ActivityType == "Opportunity") {
            OpporID = RefferenceID;
            ActivityCategory = "Opportunity"
            LeadID = "";
            QuotationID = "";
            SalesOrderID = "";
        }
        else if (ActivityType == "Lead" || props.ActivityType == "Lead") {
            LeadID = RefferenceID;
            ActivityCategory = "Lead"
            OpporID = "";
            QuotationID = "";
            SalesOrderID = "";
        }
        else if (ActivityType == "Quotation" || props.ActivityType == "Quotation") {
            QuotationID = RefferenceID;
            ActivityCategory = "Quotation"
            OpporID = "";
            LeadID = "";
            SalesOrderID = "";
        }
        else if (ActivityType == "SalesOrder" || props.ActivityType == "SalesOrder") {
            SalesOrderID = RefferenceID;
            ActivityCategory = "SalesOrder"
            OpporID = "";
            LeadID = "";
            QuotationID = "";
        }
        else if (ActivityType == "Others" || props.ActivityType == "Others") {
            SalesOrderID = "";
            ActivityCategory = "Others"
            OpporID = "";
            LeadID = "";
            QuotationID = "";
        }
        if (props.ActivityID !== "") {
            Activityid = props.ActivityID;
        }
        else {
            Activityid = "";
        }
        Statuss = "Pending";
        // if (sts !== undefined && sts !== "") {
        //     Statuss = "Completed";
        // }
        if (props.AccountID !== undefined && props.AccountID !== "") {
            if (AccType === "Lead") {
                LeadID = RefferenceID;
                ActivityCategory = "Lead"
                OpporID = "";
                QuotationID = "";
                SalesOrderID = "";
            }
            else if (AccType === "Quotation") {
                QuotationID = RefferenceID;
                ActivityCategory = "Quotation"
                OpporID = "";
                LeadID = "";
                SalesOrderID = "";
            }
            else if (AccType === "Opportunity") {
                OpporID = RefferenceID;
                ActivityCategory = "Opportunity"
                LeadID = "";
                QuotationID = "";
                SalesOrderID = "";
            }
            else if (AccType === "SalesOrder") {
                SalesOrderID = RefferenceID;
                ActivityCategory = "SalesOrder"
                QuotationID = "";
                LeadID = "";
                OpporID = "";
            }
            else {
                ActivityCategory = "Others"

            }
        }
        bodyFormData.append("UserGroupID", sessionStorage.UserGroupID);
        bodyFormData.append("ActivityID", ActivityID);
        bodyFormData.append("ActivityDate", Date);
        bodyFormData.append("EmployeeID", EmployeeID);
        var momentObj = Moment(Date + StartTime, 'YYYY-MM-DD h:mm:ss a');
        var dateStartTime = momentObj.format('YYYY-MM-DD h:mm:ss a');
        bodyFormData.append("ActivityStartTime", dateStartTime);
        var momentObj1 = Moment(Date + EndTime, 'YYYY-MM-DD h:mm:ss a');
        var dateEndTime = momentObj1.format('YYYY-MM-DD h:mm:ss a');
        bodyFormData.append("ActivityEndTime", dateEndTime);
        bodyFormData.append("ActivityTypeID", ActivityTypeID);
        bodyFormData.append("CustomerID", CustID);
        bodyFormData.append("ContactID", ContactID);
        bodyFormData.append("Description", Description);
        bodyFormData.append("OpportunityID", OpporID);
        bodyFormData.append("LeadID", LeadID);
        bodyFormData.append("QuotationID", QuotationID);
        bodyFormData.append("SalesOrderID", SalesOrderID);
        bodyFormData.append("CreatedByID", UserID);
        bodyFormData.append("Status", Statuss);
        bodyFormData.append("ActivityCategory", ActivityCategory);
        fetchData("Activity/SaveActivity", bodyFormData);
    }

    useEffect(() => {
        const input = ref.current;
        if (input) input.setSelectionRange(cursor, cursor);
    }, [ref, cursor, value]);

    const handleChange = (e) => {
        // setCursor(e.target.selectionStart);
        onChange && onChange(e);
    };

    const onSubmit = values => {
        // debugger;
        var Statuss;
        var ActivityCategory;
        var EmployeeID = sessionStorage.UID;
        var UserID = sessionStorage.UID;
        var bodyFormData = new FormData();
        var OpporID, LeadID, QuotationID, SalesOrderID, Activityid = "";
        // debugger;
        if (ActivityType == "Opportunity" || props.ActivityType == "Opportunity") {
            OpporID = RefferenceID;
            ActivityCategory = "Opportunity"
            LeadID = "";
            QuotationID = "";
            SalesOrderID = "";
        }
        else if (ActivityType == "Lead" || props.ActivityType == "Lead") {
            LeadID = RefferenceID;
            ActivityCategory = "Lead"
            OpporID = "";
            QuotationID = "";
            SalesOrderID = "";
        }
        else if (ActivityType == "Quotation" || props.ActivityType == "Quotation") {
            QuotationID = RefferenceID;
            ActivityCategory = "Quotation"
            OpporID = "";
            LeadID = "";
            SalesOrderID = "";
        }
        else if (ActivityType == "SalesOrder" || props.ActivityType == "SalesOrder") {
            SalesOrderID = RefferenceID;
            ActivityCategory = "SalesOrder"
            OpporID = "";
            LeadID = "";
            QuotationID = "";
        }
        else {
            SalesOrderID = "";
            ActivityCategory = "Others"
            OpporID = "";
            LeadID = "";
            QuotationID = "";
        }
        if (props.ActivityID !== "") {
            Activityid = props.ActivityID;
        }
        else {
            Activityid = ""
        }
        var Statuss = StatusC;
        if (props.AccountID !== undefined && props.AccountID !== "") {
            if (AccType === "Lead") {
                LeadID = RefferenceID;
                ActivityCategory = "Lead"
                OpporID = "";
                QuotationID = "";
                SalesOrderID = "";
            }
            else if (AccType === "Quotation") {
                QuotationID = RefferenceID;
                ActivityCategory = "Quotation"
                OpporID = "";
                LeadID = "";
                SalesOrderID = "";
            }
            else if (AccType === "Opportunity") {
                OpporID = RefferenceID;
                ActivityCategory = "Opportunity"
                LeadID = "";
                QuotationID = "";
                SalesOrderID = "";
            }
            else if (AccType === "SalesOrder") {
                SalesOrderID = RefferenceID;
                ActivityCategory = "SalesOrder"
                QuotationID = "";
                LeadID = "";
                OpporID = "";
            }
            else {
                //SalesOrderID = "";
                ActivityCategory = "Others"
                //OpporID = "";
                //LeadID = "";
                //QuotationID = "";
            }
        }
        bodyFormData.append("ActivityID", ActivityID);
        bodyFormData.append("ActivityDate", values.Date);
        bodyFormData.append("EmployeeID", EmployeeID);
        var momentObj = Moment(values.Date + values.StartTime, 'YYYY-MM-DD h:mm:ss a');
        var dateStartTime = momentObj.format('YYYY-MM-DD h:mm:ss a');
        bodyFormData.append("ActivityStartTime", dateStartTime);
        var momentObj1 = Moment(values.Date + values.EndTime, 'YYYY-MM-DD h:mm:ss a');
        var dateEndTime = momentObj1.format('YYYY-MM-DD h:mm:ss a');
        bodyFormData.append("ActivityEndTime", dateEndTime);
        bodyFormData.append("ActivityTypeID", values.ActivityTypeID);
        bodyFormData.append("CustomerID", CustID);
        bodyFormData.append("ContactID", values.ContactID);
        bodyFormData.append("Description", values.Description);
        bodyFormData.append("OpportunityID", OpporID);
        bodyFormData.append("LeadID", LeadID);
        bodyFormData.append("QuotationID", QuotationID);
        bodyFormData.append("SalesOrderID", SalesOrderID);
        bodyFormData.append("CreatedByID", UserID);
        bodyFormData.append("Status", Statuss);
        bodyFormData.append("ActivityCategory", ActivityCategory);
        fetchData("Activity/SaveActivity", bodyFormData);
    }

    const OnDelete = () => {
        // debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("ActivityID", props.ActivityID);
        fetchDelete("Activity/DeleteActivity", bodyFormData);
        props.setOpen(false);
    }

    const GetByIDData = () => {
        // debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("ActivityID", props.ActivityID);
        fetchDisplayData("Activity/GetByID", bodyFormData);
    }

    const leadReffDoc = () => {
        // debugger;
        //if (props.AccountID !== undefined && props.AccountID !== "") {
        var bodyFormData = new FormData();
        let activitytype = "Lead"
        bodyFormData.append("AccountID", props.AccountID);
        bodyFormData.append("ActivityType", activitytype);
        fetchRefferenceDtls("Activity/GetRefference", bodyFormData);
        setAccType("Lead");
        //}
    }

    const OpporReffDoc = () => {
        // debugger;
        //if (props.AccountID !== undefined && props.AccountID !== "") {
        var bodyFormData = new FormData();
        let activitytype = "Opportunity"
        bodyFormData.append("AccountID", props.AccountID);
        bodyFormData.append("ActivityType", activitytype);
        fetchRefferenceDtls("Activity/GetRefference", bodyFormData);
        setAccType("Opportunity");
        //}
    }
    const QuotationReffDoc = () => {
        // if (props.AccountID !== undefined && props.AccountID !== "") {
        var bodyFormData = new FormData();
        let activitytype = "Quotation"
        bodyFormData.append("AccountID", props.AccountID);
        bodyFormData.append("ActivityType", activitytype);
        fetchRefferenceDtls("Activity/GetRefference", bodyFormData);
        setAccType("Quotation");
        // }
    }
    const SalesOrderReffDoc = () => {
        var bodyFormData = new FormData();
        let activitytype = "SalesOrder"
        bodyFormData.append("AccountID", props.AccountID);
        bodyFormData.append("ActivityType", activitytype);
        fetchRefferenceDtls("Activity/GetRefference", bodyFormData);
        setAccType("SalesOrder");
    }

    const onCheck = (e) => {
        // debugger;
        let targetvalue = e.target.value;
        let targetname = e.target.name;
        console.log(targetvalue);
        if (targetvalue !== "") {
            setActivityType(targetname);
            if (targetname === "Lead") {
                setLead(true);
                //leadReffDoc();
                setOpportunity(false);
                setQuotation(false);
                setComplaint(false);
                setSalesOrder(false);
                setOthers(false);
            }
            if (targetname === "Opportunity") {
                setOpportunity(true);
                //OpporReffDoc();
                setLead(false);
                setQuotation(false);
                setComplaint(false);
                setSalesOrder(false);
                setOthers(false);
            }
            if (targetname === "Quotation") {
                setQuotation(true);
                //QuotationReffDoc();
                setLead(false);
                setOpportunity(false);
                setComplaint(false);
                setSalesOrder(false);
                setOthers(false);
            }
            if (targetname === "Complaint") {
                setComplaint(true);
                setLead(false);
                setOpportunity(false);
                setQuotation(false);
                setSalesOrder(false);
                setOthers(false);
            }
            if (targetname === "SalesOrder") {
                setSalesOrder(true);
                //SalesOrderReffDoc();
                setLead(false);
                setOpportunity(false);
                setQuotation(false);
                setComplaint(false);
                setOthers(false);
            }
            if (targetname === "Others") {
                setOthers(true);
                setSalesOrder(false);
                //SalesOrderReffDoc();
                setLead(false);
                setOpportunity(false);
                setQuotation(false);
                setComplaint(false);

            }
        }
    }

    const onCustChange = (event, newValue) => {
        // debugger;
        setCustID(newValue.id);
        setCustName(newValue);
        setAccountID(newValue.id);
        getContactDtls(newValue.id)
        getRefferenceDtls(newValue.id)
    }

    const ContactOnChange = (Contact) => {
        var bodyFormData = new FormData();
        if (Contact !== "" && CustID !== "" && Contact !== null && CustID !== null) {
            bodyFormData.append("AccountID", CustID);
            bodyFormData.append("ContactID", ContactID);
            fetchContByIDDtls("Activity/GetContactID", bodyFormData);
        }
    }

    const getRefferenceDtls = async (CID) => {
        var bodyFormData = new FormData();
        let ActivityTypeValue;
        if (ActivityType == "Opportunity" || props.ActivityType == "Opportunity") {
            ActivityTypeValue = "Opportunity"
        } else if (ActivityType == "Quotation" || props.ActivityType == "Quotation") {
            ActivityTypeValue = "Quotation"
        } else if (ActivityType == "SalesOrder" || props.ActivityType == "SalesOrder") {
            ActivityTypeValue = "SalesOrder"
        } else if (ActivityType === "Lead" || props.ActivityType === "Lead") {
            ActivityTypeValue = "Lead"
        }
        // debugger;
        if (CID !== "" && CustID !== null) {
            bodyFormData.append("AccountID", CID);
            bodyFormData.append("ActivityType", ActivityTypeValue);
            fetchRefferenceDtls("Activity/GetRefference", bodyFormData);
        }
        else if (ActivityType === "Lead" || props.ActivityType === "Lead") {
            bodyFormData.append("AccountID", '');
            bodyFormData.append("ActivityType", 'Lead');
            fetchRefferenceDtls("Activity/GetRefference", bodyFormData);
        }
    }
    const getRefferenceDate = (RefDocumentID) => {
        var bodyFormData = new FormData();
        bodyFormData.append("RefDocumentID", RefDocumentID);
        bodyFormData.append("ActivityType", props.ActivityType);
        fetchDate("Activity/GetRefDate", bodyFormData);
    }

    const getContactDtls = (CID) => {
        var bodyFormData = new FormData();
        bodyFormData.append("AccountID", CID);
        fetchContDtls("Activity/GetContactID", bodyFormData);
    }

    const TypeData = (options) => {
        if (options !== undefined) {
            let Type = options.map((data) => (
                <option key={data.ActivityType} value={data.ActivityTypeID}>
                    {data.ActivityType}
                </option>
            ));
            setTypecmb(Type);
        }
    };

    const ContactData = (options) => {
        if (options !== undefined) {
            let cmbContact = options.map((data) => (
                <option key={data.ContactName} value={data.ContactID}>
                    {data.ContactName}
                </option>
            ));
            setContactcmb(cmbContact);
        }
    };

    const RefferenceData = (options) => {
        // debugger;
        if (options !== undefined) {
            let Refferencecmb = options.map((data) => (
                <option key={data.no} value={data.id}>
                    {data.no}
                </option>
            ));
            setRefferencecmb(Refferencecmb);
        }
    };
    const CustData = () => {
        var bodyFormData = new FormData();
        fetchCustData("Activity/ComboData", bodyFormData);
    }
    useEffect(() => {
        if (responseCust['cmbAccount'] !== undefined && responseCust['cmbAccount'].length > 0) {
            setCustOptions(responseCust['cmbAccount']);
        }
    }, [responseCust['cmbAccount']])

    useEffect(() => {
        if (responseContByIDDtls !== undefined && responseContByIDDtls.length > 0) {
            if (responseContByIDDtls[0].Mobile !== null) {
                setMobileNo(responseContByIDDtls[0].Mobile);
            }
            else {
                setMobileNo('')
            }
            if (responseContByIDDtls[0].Address1 !== null) {
                setAddress(responseContByIDDtls[0].Address1 + " " + responseContByIDDtls[0].Address2);
            }
            else {
                setAddress('');
            }
        }
    }, [responseContByIDDtls])

    useEffect(() => {
        if (ResponseDate !== undefined && ResponseDate.length > 0) {
            setCurDate(ResponseDate[0].Date);
        }
    }, [ResponseDate])

    useEffect(() => {
        if (ResponseDisplay !== undefined && ResponseDisplay.length > 0) {
            getContactDtls(ResponseDisplay[0].AccountID === null ? "" : ResponseDisplay[0].AccountID);
            getRefferenceDtls(ResponseDisplay[0].AccountID === null ? "" : ResponseDisplay[0].AccountID);
            setDate(
                ResponseDisplay[0].ActivityDate === null
                    ? ""
                    : Moment(ResponseDisplay[0].ActivityDate).format("YYYY-MM-DD")
            );
            var a = Moment(ResponseDisplay[0].ActivityStartTime).format("HH:mm");
            // debugger;
            setStartTime(a);
            setEndTime(Moment(ResponseDisplay[0].ActivityEndTime).format("HH:mm"));
            setActivityID(ResponseDisplay[0].ActivityID === null ? "" : ResponseDisplay[0].ActivityID);
            setActivityTypeID(ResponseDisplay[0].ActivityTypeID === null ? "" : ResponseDisplay[0].ActivityTypeID);
            setCustName({ id: ResponseDisplay[0].AccountID, List: ResponseDisplay[0].AccountName });
            setCustID(ResponseDisplay[0].AccountID === null ? "" : ResponseDisplay[0].AccountID);
            setContactID(ResponseDisplay[0].ContactID === null ? "" : ResponseDisplay[0].ContactID);
            setDescription(ResponseDisplay[0].Description);
            setMobileNo(ResponseDisplay[0].Mobile);
            setStatus(ResponseDisplay[0].Status);
            // debugger;
            if (ResponseDisplay[0].ActivityCategory === "Lead") {
                //leadReffDoc();
                setRefferenceID(ResponseDisplay[0].LeadID === null ? "" : ResponseDisplay[0].LeadID);
                setCurDate(ResponseDisplay[0].LeadDate);
                //setCurDate(ResponseDisplay[0].LeadDate === null ? "" : Moment(ResponseDisplay[0].LeadDate).format("DD MMM yyyy"));
                setLead(true);
            }
            else if (ResponseDisplay[0].ActivityCategory === "Opportunity") {
                //OpporReffDoc();
                // debugger;
                setRefferenceID(ResponseDisplay[0].OpportunityID === null ? "" : ResponseDisplay[0].OpportunityID);
                setCurDate(ResponseDisplay[0].OpportunityDate);
                setOpportunity(true);
            }
            else if (ResponseDisplay[0].ActivityCategory === "Quotation") {
                setRefferenceID(ResponseDisplay[0].QuotationID === null ? "" : ResponseDisplay[0].QuotationID);
                setActivityID(ResponseDisplay[0].ActivityID === null ? "" : ResponseDisplay[0].ActivityID);
                setCurDate(ResponseDisplay[0].QuotationDate);
                setQuotation(true);
            }
            else if (ResponseDisplay[0].ActivityCategory === "SalesOrder") {
                setRefferenceID(ResponseDisplay[0].SalesOrderID === null ? "" : ResponseDisplay[0].SalesOrderID);
                setCurDate(ResponseDisplay[0].SalesOrderDate);
                setSalesOrder(true);
            }
            setAddress(ResponseDisplay[0].Address1 === null ? "" : ResponseDisplay[0].Address1);
        }
    }, [ResponseDisplay])

    useEffect(() => {
        if (responseContDtls !== undefined && responseContDtls.length > 0) {
            ContactData(responseContDtls)
        }
    }, [responseContDtls]);

    useEffect(() => {
        if (responseRefferenceDtls !== undefined && responseRefferenceDtls.length > 0) {
            RefferenceData(responseRefferenceDtls)
        }
    }, [responseRefferenceDtls]);

    useEffect(() => {
        if (ComboDataResponse !== undefined && ComboDataResponse.length > 0) {
            TypeData(ComboDataResponse);
        }
    }, [ComboDataResponse]);

    useEffect(() => {
        ActivityTypeData();
        CustData();
        getRefferenceDtls('');
        // debugger;
        if (props.AccountID !== undefined && props.AccountID !== "") {
            setCustName({ id: props.AccountID, List: props.AccountName });
            getContactDtls(props.AccountID);
            setCustID(props.AccountID);
            getRefferenceDtls(props.AccountID);
        }
        if (props.ActivityID !== "") {
            GetByIDData();
        }
        if (props.ActivityType === "Opportunity") {
            setOpportunity(true);
        }
        else if (props.ActivityType === "Lead") {
            setLead(true);
        }
        else if (props.ActivityType === "Quotation") {
            setQuotation(true);
            setActivityType(ActivityID);
        }
        else if (props.ActivityType === "SalesOrder") {
            setSalesOrder(true);
        }
    }, []);

    const ActivityTypeData = () => {
        fetchComboData("Activity/ComboActivityType");
    };

    useEffect(() => {
        // debugger;
        if ((ResponseSave.Response === true) && (Mode === 'MarkAsComplete')) {
            alert('Data Saved Succesfully.');
            ClearData();
            try {
                props.Populate('');
            } catch (error) {
                console.log(error);
            }
        }
        else if (ResponseSave.Response === true) {
            if (pageName === 'Activities') {
                alert('Data Saved Succesfully.');
                props.setOpen(false);
                props.PopulateData();

            }
            else if (pageName === 'Dash') {
                alert('Data Saved Succesfully.');
                props.setOpen(false);
                props.Populate('');
            }
            else {
                alert('Data Saved Succesfully.');
                props.setOpen(false);
                props.PopulateData();
            }

            try {
            } catch (error) {
                console.log(error);
            }
        }
        else if (ResponseSave.Response === false) {
            alert('Failed.');
        }

    }, [ResponseSave])


    useEffect(() => {
        // debugger;
        if (ResponseDelete.Response === true) {
            if (pageName === 'Dash') {
                props.setOpen(false);
                props.Populate('');
            }
            else {
                props.setOpen(false);
                props.PopulateData();
            }

        } else if (ResponseDelete.Response === false) {
            alert("Failed.");
        }
    }, [ResponseDelete]);

    const onSelectChange = (e) => {
        let targetvalue = e.target.value;
        let targetname = e.target.name;
        if (targetvalue !== "") {
            if (targetname === "ActivityTypeID") {
                setActivityTypeID(targetvalue);
            }
            if (targetname === "ContactID") {
                setContactID(targetvalue);
                ContactOnChange(targetvalue);
            }
            if (targetname === "RefferenceID") {
                setRefferenceID(targetvalue);
                getRefferenceDate(targetvalue);
            }
        }
        else {
            if (targetname === "ActivityTypeID") {
                setActivityTypeID("");
            }
        }
    }

    return (
        <div>
            <Formik initialValues={{
                Lead: Lead, Opportunity: Opportunity, Quotation: Quotation, SalesOrder: SalesOrder, Complaint: Complaint, Others: Others, ActivityTypeID: ActivityTypeID, ContactID: ContactID,
                Description: Description, MobileNo: MobileNo, Address: Address, Date: Date, StartTime: StartTime, EndTime: EndTime, CurDate: CurDate, RefferenceID: RefferenceID
            }}
                validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={1} container direction="row" >

                            <Grid item xs={1} style={{ marginLeft: 250 }}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='checkbox'
                                    name='Quotation'
                                    onChange={onCheck}
                                />
                            </Grid>
                            <Grid item xs={1} >
                                <label htmlFor={"Quotation"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"Quotation"}
                                </label>
                            </Grid>
                            <Grid item xs={1}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='checkbox'
                                    name='Others'
                                    onChange={onCheck}
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <label htmlFor={"Others"} style={{ display: 'block', width: '100%' }}>
                                    {"Others"}
                                </label>
                            </Grid>
                            <Grid item xs={12} container direction="row">
                                <Grid item xs={2}>
                                    <label htmlFor={"Employee"}
                                        style={{
                                            display: 'block', width: '100%'
                                        }}>
                                        {"Employee"}
                                    </label>
                                </Grid>
                                <Grid item xs>
                                    <BiztranControlsFormik
                                        control='input'
                                        type='text'
                                        value={sessionStorage.UserName}
                                        disabled={true}
                                        name='Employee'
                                        onChange={(e) => setEmployee(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={1}>
                                    <label htmlFor={"ActivityTypeID"}
                                        style={{
                                            display: 'block', width: '100%', marginLeft: 7, marginTop: 5
                                        }}>
                                        {"Type"}
                                    </label>
                                </Grid>
                                <Grid item xs>
                                    <BiztranControlsFormik
                                        control='select'
                                        name='ActivityTypeID'
                                        options={Typecmb}
                                        onChange={onSelectChange}
                                    />
                                </Grid>
                                <Grid item xs={1}>
                                    <label htmlFor={"ActivityStatusID"}
                                        style={{
                                            display: 'block', width: '100%', marginLeft: 7, marginTop: 5
                                        }}>
                                        {"Status"}
                                    </label>
                                </Grid>
                                <Grid item xs>
                                    <label htmlFor={"ActivityStatusID"}
                                        style={{
                                            display: 'block', width: '100%', color: "rgb(0, 144, 64)"
                                        }}>
                                        <h4>{Status}</h4>
                                    </label>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container direction="row">
                                <Grid item xs={2}>
                                    <label htmlFor={"Date"}
                                        style={{
                                            display: 'block', width: '100%'
                                        }}>
                                        {"Date"}
                                    </label>
                                </Grid>
                                <Grid item xs>
                                    <BiztranControlsFormik
                                        control="input"
                                        type="date"
                                        name="Date"
                                        onChange={(e) => setDate(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={1}>
                                    <label htmlFor={"SatrtTime"}
                                        style={{
                                            display: 'block', width: '100%', marginLeft: 7, marginTop: 5
                                        }}>
                                        {"Start Time"}
                                    </label>
                                </Grid>
                                <Grid item xs>
                                    <BiztranControlsFormik
                                        control='input'
                                        type='time'
                                        name='SatrtTime'
                                        value={StartTime}
                                        onChange={(e) => setStartTime(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={1}>
                                    <label htmlFor={"EndTime"}
                                        style={{
                                            display: 'block', width: '100%', marginLeft: 7, marginTop: 5
                                        }}>
                                        {"End Time"}
                                    </label>
                                </Grid>
                                <Grid item xs>
                                    <BiztranControlsFormik
                                        control='input'
                                        type='time'
                                        name='EndTime'
                                        value={EndTime}
                                        onChange={(e) => setEndTime(e.target.value)}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container direction="row" >
                                <Grid item xs={2}>
                                    <label htmlFor={"Customer"}
                                        style={{
                                            display: 'block', width: '100%'
                                        }}>
                                        {"Customer"}
                                    </label>
                                </Grid>
                                <Grid item xs={10}>
                                    <BiztranControls.Autocomplete
                                        options={CustOptions}
                                        onChange={onCustChange}
                                        value={CustName}
                                        disabled={props.DisableCustomer}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={2}>
                                <label htmlFor={"ContactID"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"Contact"}
                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <BiztranControlsFormik
                                    control='select'
                                    name='ContactID'
                                    options={Contactcmb}
                                    onChange={onSelectChange}
                                    disabled={props.DisableContact}
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <label htmlFor={"MobileNo"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"Mobile No"}
                                </label>
                            </Grid>
                            <Grid item xs={5}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    name='MobileNo'
                                    disabled={true}
                                    onChange={(e) => setMobileNo(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <label htmlFor={"Address"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"Address"}
                                </label>
                            </Grid>
                            <Grid item xs={10}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    disabled={true}
                                    name='Address'
                                    onChange={(e) => setAddress(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <label htmlFor={"RefferenceID"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"Refference Doc"}
                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <BiztranControlsFormik
                                    control='select'
                                    name='RefferenceID'
                                    options={Refferencecmb}
                                    onChange={onSelectChange}
                                    disabled={props.DisableRefDoc}
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <label htmlFor={"CurDate"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"Date"}
                                </label>
                            </Grid>
                            <Grid item xs={5}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    disabled={true}
                                    name='CurDate'
                                />
                            </Grid>

                            <Grid item xs={2}>
                                <label htmlFor={"Description"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"Description/Remark"}
                                </label>
                            </Grid>
                            <Grid item xs={10}>
                                <BiztranControlsFormik
                                    autoFocus="autofocus"
                                    control='textarea'
                                    type='text'
                                    name='Description'
                                    ref={ref}
                                    value={Description}
                                    onChange={(e) => {
                                        setDescription(e.target.value)
                                        handleChange()
                                    }}
                                />
                            </Grid>
                            <Grid item xs={2}></Grid>
                            <Grid item xs={12} style={{}}>
                                <a href="javascript:;" onClick={() => { MarkAsComplete(); }} >
                                    Mark as Complete & Create new Activity
                                </a>

                            </Grid>
                        </Grid>
                        <Grid spacing={2} container direction="row">
                            <Grid item xs={12}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                        <BiztranControls.Button
                                            text="Update"
                                            onClick={OnUpdate}
                                            startIcon={<SaveIcon />}
                                            disabled={DisableUpdate}
                                        />
                                        <BiztranControls.Button
                                            text="Complete"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                            disabled={DisableComplete}
                                        />
                                        <BiztranControls.Button
                                            text="Delete"
                                            startIcon={<CloseIcon />}
                                            onClick={OnDelete}
                                            disabled={DisableDelete}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
};

export default CreateActivities;
